import React from "react";
import MultiSelectDropdown from "../../components/multiSelectDropdown/multiSelectDropdown";

const Filter = ({
  selectedFilters,
  options,
  onChange,
  isMulti = true,
  keys,
  manySelectedPlaceholder = undefined,
  allSelectedPlaceholder = undefined,
  numberDisplayed = 1
}) => {
  const filterKeys = { label: "name", value: "id", ...keys };

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedFilters}
      enableOnly={isMulti}
      includeSelectAll={isMulti}
      labelKey={filterKeys.label}
      valueKey={filterKeys.value}
      numberDisplayed={numberDisplayed}
      filterPlaceholder=""
      placeholder="Sales Package"
      manySelectedPlaceholder={manySelectedPlaceholder}
      allSelectedPlaceholder={allSelectedPlaceholder}
      haveOnSelectChange
      onSelectChange={onChange}
      includeFilter={false}
    />
  );
};

export default Filter;
